// TODO: add flow types

import spaCategory from './factories/spaCategory';

/**
 * Path: /schoenheit-und-gesundheit/spa/:categoryId
 * Renders all spa offers from /spa/beauty with the given categoryId
 */
export default spaCategory('beauty', 'spa-more', 'spaBalconyCabin');
